var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_1745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8658 6.56621C16.774 6.4005 16.6394 6.26249 16.476 6.16659C16.3127 6.07068 16.1266 6.0204 15.9371 6.021H5.86952C5.53009 6.02099 5.19981 6.13107 4.92826 6.33473C4.65671 6.53838 4.45854 6.82462 4.3635 7.15047L2.37078 13.9827C2.26587 14.3423 2.04714 14.6583 1.74741 14.883C1.44769 15.1078 1.08315 15.2293 0.708496 15.2293H13.3692C13.7439 15.2293 14.1085 15.1078 14.4083 14.883C14.7081 14.6581 14.9269 14.3421 15.0318 13.9824L16.9448 7.42382C16.9893 7.28279 17.0052 7.13431 16.9916 6.98705C16.9781 6.8398 16.9353 6.69673 16.8658 6.56621Z",
    fill: "#06B6D4",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68937 13.7843L3.68333 6.95245C3.82224 6.48015 4.11002 6.06537 4.50378 5.76988C4.89755 5.4744 5.37624 5.31403 5.86854 5.31266H14.875V4.9585C14.875 4.58277 14.7257 4.22244 14.4601 3.95676C14.1944 3.69108 13.8341 3.54183 13.4583 3.54183H8.05931C7.95377 3.54183 7.84955 3.5183 7.75424 3.47297C7.65893 3.42763 7.57493 3.36163 7.50833 3.27975L6.81215 2.42369C6.6463 2.21978 6.43709 2.05539 6.19973 1.94249C5.96238 1.82959 5.70284 1.771 5.44 1.771H1.41667C1.04094 1.771 0.680609 1.92025 0.414932 2.18593C0.149256 2.4516 0 2.81194 0 3.18766L0 13.8127C0 14.0005 0.0746278 14.1807 0.207466 14.3135C0.340304 14.4464 0.520472 14.521 0.708333 14.521C0.929423 14.5204 1.14439 14.4483 1.32119 14.3156C1.49799 14.1828 1.62713 13.9965 1.68937 13.7843Z",
    fill: "#06B6D4",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_1745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcons);
export default __webpack_public_path__ + "static/media/DocumentIcons.9a20dad2fa460e0a012d5699e37ae3bb.svg";
export { ForwardRef as ReactComponent };